<template>
  <Tooltip :text="popupText" trigger="hover" class="w-full">
    <div class="flex max-w-[150px]">
      <div :class="'text-text1 dark:text-dmText1 overflow-hidden overflow-ellipsis ' + textClasses">{{ text }}</div>
      <img :src="copyIcon" class="copy-icon cursor-pointer" alt="copy" @click="copyToClipboard" />
    </div>
  </Tooltip>
</template>

<script lang="ts" setup>
import copyIcon from '~/assets/icons/copy-icon.svg'
import clipboard from 'clipboardy'

const { t } = useLang()

const props = defineProps({
  placement: {
    type: String,
    default: 'top',
  },
  text: {
    type: String,
    default: '',
  },
  textClasses: {
    type: String,
    default: '',
  },
})

const popupText = ref(props.text)
let timeoutId: NodeJS.Timeout | null = null

function copyToClipboard() {
  clipboard
    .write(props.text)
    .then(() => {
      popupText.value = t('copy.success_message')
      timeoutId = setTimeout(() => {
        popupText.value = props.text
      }, 2000)
    })
    .catch(() => {
      popupText.value = t('copy.error_message')
      timeoutId = setTimeout(() => {
        popupText.value = props.text
      }, 4000)
    })
}

onBeforeUnmount(() => {
  if (timeoutId) {
    clearTimeout(timeoutId)
  }
})
</script>

<style lang="scss" scoped>
.copy-icon {
  padding-left: 0.25rem;

  filter: invert(41%) sepia(0%) saturate(1%) hue-rotate(235deg) brightness(95%) contrast(90%);

  &:hover {
    filter: theme('vars.blackToOrangeFilters');
  }
}

:deep(.tooltip-wrapper) {
  max-width: 100%;
}
</style>
